import { SET_IS_OPEN_MODAL } from '../actionTypes';
import { resetPasswordUserActions } from '../reducer';

export default (value) => resetPasswordUserActions[SET_IS_OPEN_MODAL](value);
